<span class="custom-snackbar-frame" width="100%">
    <div class="custom-snackbar-{{data.severity}}-bar"></div>
    <div class="custom-snackbar-inner">
        <div class="custom-snackbar-icon"><img src="./assets/icons/{{data.severity}}.png"></div>
        <span class="custom-snackbar-content" matSnackBarLabel>
            <div class="snackbar-header">{{data.header}}</div>
            <div class="snackbar-text">{{data.message}}</div>
        </span>
    </div>
</span>